import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {Box, Button, Card, CardHeader, Checkbox, Grid, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography, makeStyles, TextField, Paper } from '@material-ui/core';
import  store  from "../../../redux/store";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }, 
}));

const Results = ({ className, worklists, ...rest }) => {
  const state = store.getState();
  const {role } = state;
  const classes = useStyles();
  const [selectedWorkIds, setSelectedWorkIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const handleLimitChange = (event) => { setLimit(event.target.value); };
  const handlePageChange = (event, newPage) => { setPage(newPage); }; 

  return (
    <Grid container spacing={2}>
       <Grid item xs={12}>
      <CardHeader title="Completed works needs hour entry"></CardHeader>
        <Card className={clsx(classes.root, className)} {...rest}>
          <PerfectScrollbar>
            <Box minWidth={1050}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{width: "15%"}}>Date</TableCell>
                    <TableCell style={{width: "25%"}}>Work Description</TableCell>

                    {["Admin","Client"].includes(role) ?
                    <TableCell style={{width: "25%"}}>Worker</TableCell>
                    : null }
                    
                    <TableCell style={{width: "20%"}}>Work Hour </TableCell> 
                    <TableCell style={{width: "15%"}}>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {worklists.map((work) => (
                    <TableRow hover key={work.id} selected={selectedWorkIds.indexOf(work.id) !== -1} className={clsx(classes.completedWorksNeedsHourEntryRow, className)}>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{moment(work.startedAt).format('DD/MM/YYYY')}</TableCell>
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{work.workdescription}</TableCell>

                      {["Admin","Client"].includes(role) ?
                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>{work.worker}</TableCell>
                      : null }

                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}> 

                        {["Admin","Worker"].includes(role) ?
                        <div className={classes.root}>
                        <Grid container spacing={1} xs={6} sm={6}>
                          <Grid item xs={6} sm={6}>
                            <TextField inputProps = {{ style: { padding: 5 }}} fullWidth name="firstName" value = "09:00" disabled = { role === "Admin" } variant = { role === "Admin" ? "filled" : "outlined" } />
                          </Grid>
                          <Grid item xs={6} sm={6}>
                            <TextField inputProps = {{ style: { padding: 5 }}} fullWidth name="firstName" variant = { role === "Admin" ? "filled" : "outlined" } value = "18:00" disabled = { role === "Admin" } /> 
                          </Grid>
                        </Grid>                      
                        </div> : null }

                        {["Admin","Client"].includes(role) ?
                        <div className={classes.root}>
                          <Grid container spacing={1} xs={6} sm={6}>
                            <Grid item xs={6} sm={6}>
                              <TextField inputProps = {{ style: { padding: 5 }}} fullWidth name="firstName" variant = { role === "Admin" ? "filled" : "outlined" } value="09:00" disabled = { role === "Admin" }/>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <TextField inputProps = {{ style: { padding: 5 }}} fullWidth name="firstName" variant = { role === "Admin" ? "filled" : "outlined" } value="18:00" disabled = { role === "Admin" }/> 
                            </Grid>
                          </Grid>
                        </div> : null }

                        {["Admin"].includes(role) ?
                        <div className={classes.root}>
                          <Grid xs={1} sm={6} container spacing={1}>
                            <Grid item xs={12} sm={12}>
                              <TextField inputProps = {{ style: { padding: 5 }}} fullWidth name="firstName" variant="outlined" value="9" />
                            </Grid>
                          </Grid>
                        </div> : null }                        
                      </TableCell>

                      <TableCell className={clsx(classes.completedWorksNeedsHourEntryCell, className)}>
                        <Button style= {{color:"green"}} variant="outlined">Save Hour</Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination component="div" 
            count={worklists.length}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 50, 100]} />
        </Card>
      </Grid> 
     </Grid>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  worklists: PropTypes.array.isRequired
};

export default Results;
